// extracted by mini-css-extract-plugin
export default {"wrapper":"l4-z","play":"m4-z"};